/* global require */
/* eslint-disable max-len */
// modules
import React from 'react';

// aliased
import Link from 'components/Link';

// local
import styles from './data.pcss';

export default [
  {
    name: 'Valiant Labs',
    slug: 'nike-valiant-labs',
    company: 'nike',
    images: [
      require('images/portfolio/nike/nike-0.svg'),
    ],
    tech: ['AWS', 'JavaScript', 'Node.js', 'GraphQL', 'FP', 'Ramda', 'REST', 'React', 'CSS'],
    description: [
      'Leading a team of software engineers to develop new business models',
      // 'Designed and built a two-sided customization marketplace',
    ],
    dates: ['2018'],
    website: 'https://nike.com',
    links: [
  
    ],
    contributors: [
      
    ],
  },
  {
    name: 'funk-lib',
    slug: 'funk-lib',
    images: [
      require('images/portfolio/fpjs.svg'),
    ],
    tech: ['JavaScript', 'FP', 'Ramda'],
    description: [
      'FP for Vanilla JavaScript',
      'A collection of functions for working with native JavaScript types in a consistent, functional way',
    ],
    dates: ['2018'],
    website: 'https://funk-lib.com',
    links: [],
    contributors: [],
  },
  {
    name: 'reserve.com',
    slug: 'reserve-dot-com',
    company: 'reserve',
    images: [
      require('images/portfolio/reserve-web/reserve-web-0.jpg'),
      require('images/portfolio/reserve-web/reserve-web-1.jpg'),
      require('images/portfolio/reserve-web/reserve-web-2.jpg'),
      require('images/portfolio/reserve-web/reserve-web-3.jpg'),
    ],
    tech: ['JavaScript', 'AngularJS', 'HTML', 'SASS', 'Gulp'],
    description: [
      'Responsive website for restaurant discovery and reservation booking',
    ],
    dates: ['2016', '2016'],
    website: 'https://reserve.com',
    links: [
      {
        url: 'https://web.archive.org/web/20170709150144/https://blog.reserve.com/reserve-table-management',
        title: 'blog.reserve.com',
      },
      'https://angel.co/projects/288951-reserve-com?src=user_profile',
    ],
    contributors: ['jason-leibowitz'],
  },
  {
    name: 'RFR Table Management',
    slug: 'reserve-rfr-web',
    company: 'reserve',
    images: [
      require('images/portfolio/rfr-web/rfr-web-0.jpg'),
      require('images/portfolio/rfr-web/rfr-web-1.jpg'),
      require('images/portfolio/rfr-web/rfr-web-2.gif'),
    ],
    tech: ['React', 'JavaScript', 'PostCSS', 'Redux', 'Immutable.js', 'Ramda', 'Webpack', 'Enzyme'],
    description: [
      'Led the web-team\'s development of the back-of-house admin portal for "Reserve for Restaurants", Reserve\'s table management platform',
      'Enables restaurant stakeholders to configure: floor plans, shift settings, guest messaging, reservation rules, and more',
      'Responsive drag-and-drop floor plan editor built with react + immutable remains performant with over 1000 tables',
    ],
    dates: ['2016', '2017'],
    // website: 'https://reserve.com/for-restaurants',
    website: 'https://web.archive.org/web/20170608200626/https://reserve.com/for-restaurants',
    links: [
      {
        url: 'https://web.archive.org/web/20170709150144/http://blog.reserve.com/reserve-table-management/',
        title: 'blog.reserve.com',
      },
      'https://techcrunch.com/2016/05/10/reserve-for-restaurants/',
      'https://angel.co/projects/291087-reserve-for-restaurants',
    ],
    contributors: ['jason-leibowitz'],
  },
  {
    name: 'Global MPJ',
    slug: 'amex-global-mpj',
    company: 'amex',
    images: [
      require('images/portfolio/amex-mpj/amex-mpj-0.jpg'),
      require('images/portfolio/amex-mpj/amex-mpj-1.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'CSS', 'jQuery', 'Bootstrap'],
    description: [
      'The "Global Mobile Prospect Journey" is the point-of-entry for prospective Amex cardholders to explore and compare various card options',
      'Localized experiences available in four key markets - Canada, Japan, Mexico, United Kingdom',
      // 'Tech-lead',
      // 'Four-year relationship allowed multiple iterations',
    ],
    dates: ['2012', '2015'],
    website: 'https://m.americanexpress.com/jp/content/all-cards',
    links: [
      'http://www.chadwetherbee.com/2013/03/23/american-express-credit-card-comparison-tool-for-mobile-web/',
      'http://nyplusg.com/portfolio/credit-card-comparison-tool-for-amex/',
      'http://www.kristin-l-turner.com/american-express-ratings-reviews',
      'http://www.michaelburan.com/amex/',
      'https://angel.co/projects/16927-american-express-global-mobile-prospect-journey',
      {
        url: 'https://m.americanexpress.com/jp/content/all-cards',
        title: 'Experience - Japan',
      },
      {
        url: 'https://m.americanexpress.com/mx/content/nuestras-tarjetas',
        title: 'Experience - Mexico',
      },
      {
        url: 'https://m.americanexpress.com/ca/en/content/all-cards/',
        title: 'Experience - Canada',
      },
    ],
    contributors: [
      'nick-ryan',
      'michael-buran',
      'chad-wetherbee',
      'nayong-park',
      'kristin-turner',
      'justin-shephard',
    ],
  },
  {
    name: 'Pattern Cloud',
    slug: 'directv-pattern-cloud',
    company: 'directv',
    images: [
      require('images/portfolio/directv-pattern-cloud/dtv-pattern-cloud-0.jpg'),
      require('images/portfolio/directv-pattern-cloud/dtv-pattern-cloud-1.jpg'),
      require('images/portfolio/directv-pattern-cloud/dtv-pattern-cloud-2.jpg'),
    ],
    tech: ['JavaScript', 'Sails.js', 'Node.js', 'Box.com', 'HTML', 'CSS', 'AngularJS', 'EJS'],
    description: [
      'Pattern Cloud is a web-app built for internal use amongst DirecTV\'s creative and engineering staff. It promotes content discovery and reuse by exposing relations between modular UI, UX, and code patterns',
      // 'Enhances employee productivity while preserving the current workflow and content host (Box.com)',
    ],
    dates: ['2014', '2014'],
    website: '',
    links: [
      'https://angel.co/projects/16932-directv-pattern-cloud?src=user_profile',
      'http://cargocollective.com/meganellis/Pattern-Cloud',
    ],
    contributors: ['christian-glover-wilson'],
  },
  {
    name: null,
    slug: 'camerama',
    company: 'camerama',
    images: [
      require('images/portfolio/camerama/camerama-0.jpg'),
    ],
    tech: ['JavaScript', 'Sails.js', 'AWS', 'Node.js', 'MongoDB', 'EJS', 'Grunt', 'Twilio'],
    description: [
      'Encourages photo and video sharing amongst event attendees through virtual cameras',
      'Built APIs and cloud infrastructure to accomodate iOS, Android, and web applications',
      (
        <span key={ 2 }>
          <Link className={ styles.link } to={ 'https://www.forbes.com/sites/forbespr/2015/03/16/forbes-media-acquires-private-photo-sharing-app-camerama' }>{ 'Acquired by Forbes' }</Link>
          <span>{ ' in March 2015' }</span>
        </span>
      ),
    ],
    dates: ['2014', '2015'],
    website: null,
    links: [
      'https://www.forbes.com/sites/forbespr/2015/03/16/forbes-media-acquires-private-photo-sharing-app-camerama',
      'http://www.adweek.com/digital/forbes-media-buys-photo-sharing-app/',
      // 'https://www.linkedin.com/company-beta/3654281/',
      'https://www.crunchbase.com/organization/camerama',
      'https://twitter.com/cameramaapp',
    ],
  },
  {
    name: 'HIMSS iPad',
    slug: 'ccc-himss-ipad',
    company: 'ccc',
    images: [
      require('images/portfolio/ccc-himss-ipad/ccc-himss-ipad-0.jpg'),
    ],
    tech: ['iOS', 'JavaScript', 'CSS', 'HTML'],
    description: [
      'Hybrid (Web + iOS) application used by booth attendants at the 2014 "Healthcare Information and Management Systems Society" (HIMSS) conference to schedule meetings and capture contact information from attendees',
      'All features are available offline to accomodate the conference floor\'s poor network connectivity',
    ],
    dates: ['2013', '2014'],
    website: '',
    links: [],
  },
  {
    name: 'Website',
    slug: 'ccc-website',
    company: 'ccc',
    images: [
      require('images/portfolio/ccc-web/ccc-web-0.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'SASS'],
    description: [
      'Responsive website released to coincide with the CCC\'s attendance at the 2014 HIMSS conference',
    ],
    dates: ['2013', '2014'],
    website: '',
    archive: 'https://web.archive.org/web/*/http://careconnectivity.org',
    links: [
      'http://www.chadwetherbee.com/2015/08/12/care-connectivity-consortium-himss-conference-responsive-web/',
    ],
    contributors: ['chad-wetherbee'],
  },
  {
    name: 'Jane\'s 360',
    slug: 'ihs-janes-360',
    company: 'ihs',
    images: [
      require('images/portfolio/ihs-janes-360/ihs-janes-360-0.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'CSS'],
    description: [
      // 'Tech-lead',
      // 'Educated IHS engineering team',
      'Responsive website for the defense and security branch of IHS',
    ],
    dates: ['2013', '2013'],
    website: 'http://janes.com',
    links: [
      'http://www.chadwetherbee.com/2015/08/20/ihs-janes-360-redesign-and-responsive-website/',
      'http://nyplusg.com/portfolio/ihs-janes-360/',
      'http://www.kristin-l-turner.com/ihs-aerospace-defence-redesign-janes-360',
    ],
    contributors: [
      'kristin-turner',
      'johanna-kenney',
      'chad-wetherbee',
      'nayong-park',
    ],
  },
  {
    name: 'Pulse Check',
    slug: 'insperity-pulsecheck',
    company: 'insperity',
    images: [
      require('images/portfolio/insperity-pulsecheck/pulsecheck-0.jpg'),
      require('images/portfolio/insperity-pulsecheck/pulsecheck-1.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'CSS'],
    description: [
      'Online assessment tool to prepare businesses for the 2014 U.S. Healthcare Reform articles',
      'The tool consists of a short series of questions designed to identify potential Health Care Reform related challenges a business might face. Answers to these questions are then used to generate detail analysis that details potential concerns, and offers actionable guidance on how to respond',
    ],
    dates: ['2013', '2014'],
    website: '',
    links: [
      'http://www.chadwetherbee.com/2015/08/10/insperity-health-care-reform-assessment-tool/',
      'http://nyplusg.com/portfolio/health-care-reform-assessment-tool/',
      'http://www.businesswire.com/news/home/20131031006165/en/Insperity-Pulse-Check-Helps-Businesses-Navigate-Manage',
      'http://www.insperity.com/blog/health-care-reform-how-a-drop-in-job-lock-could-benefit-your-business/',
      'https://angel.co/projects/16933-insperity-pulse-check',
    ],
    contributors: [
      'christian-glover-wilson',
      'nayong-park',
      'chad-wetherbee',
    ],
  },
  {
    name: 'Project Move',
    slug: 'kp-project-move',
    company: 'kp',
    images: [
      require('images/portfolio/kp-kiosk/kp-kiosk-0.jpg'),
      require('images/portfolio/kp-kiosk/kp-kiosk-1.jpg'),
      require('images/portfolio/kp-kiosk/kp-kiosk-2.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'CSS'],
    description: [
      'Developed physical kiosk installations located in malls and other public areas in various KP markets',
      'Kiosks provide consumers with information about Kaiser Permanente, promote Kaiser Permanente’s value proposition, and position Kaiser Permanente as a trusted advisor on Health Care Reform',
    ],
    dates: ['2012', '2014'],
    website: '',
    links: [
      'http://www.chadwetherbee.com/2015/08/14/kaiser-permanete-retail-kiosk/',
      'http://nyplusg.com/portfolio/kaiser-permanete-retail-kiosk/',
      'https://angel.co/projects/16930-kaiser-permanente-retail-kiosks?src=user_profile',
    ],
    contributors: [
      'nayong-park',
      'chad-wetherbee',
    ],
  },
  {
    name: 'lazard.com',
    slug: 'lazard-dot-com',
    company: 'lazard',
    images: [
      require('images/portfolio/lazard/lazard-0.jpg'),
    ],
    tech: ['AngularJS', 'JavaScript', 'HTML', 'SASS', 'jQuery', 'Gulp'],
    description: [
      // 'Tech-lead',
      'Responsive website for the world\'s largest independent investment bank',
    ],
    dates: ['2015', '2015'],
    links: [
      'https://angel.co/projects/50804-lazard-com',
    ],
    website: 'https://lazard.com',
    contributors: [
      'jason-leibowitz',
      'nick-ryan',
      'michael-buran',
    ],
  },
  {
    name: 'OurSungevity',
    slug: 'our-sungevity',
    company: 'sungevity',
    images: [
      require('images/portfolio/sungevity/sungevity-0.jpg'),
    ],
    tech: ['Cordova', 'iOS', 'Android', 'JavaScript', 'HTML', 'SASS'],
    description: [
      'Hybrid (Web + iOS + Android) application enabling solar owners to view and share their energy production data and site images',
    ],
    dates: ['2014', '2015'],
    website: null,
    links: [
      'https://angel.co/projects/16929-oursungevity',
      'https://vimeo.com/102543946',
    ],
    contributors: ['jason-leibowitz'],
  },
  {
    name: 'Non-Latex',
    slug: 'ansell-non-latex',
    company: 'ansell',
    images: [
      require('images/portfolio/ansell/ansell-0.jpg'),
      require('images/portfolio/ansell/ansell-1.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'CSS', 'Drupal', 'PHP'],
    description: [
      'Responsive website with interactive cost savings calculator',
    ],
    dates: ['2014', '2014'],
    website: 'http://www.ansell.com/en-US/Campaigns/Non-Latex-Conversion',
    links: [],
    contributors: ['christian-glover-wilson'],
  },
  {
    name: 'Website',
    slug: 'seideman-md-web',
    company: 'dr-casey-seideman',
    images: [
      require('images/portfolio/seideman-md/seideman-md-0.png'),
    ],
    tech: ['JavaScript', 'HTML', 'PostCSS', 'React', 'Webpack', 'AWS'],
    description: [
      'Responsive website for Portland\'s top pediatric urologist',
    ],
    dates: ['2018'],
    website: 'https://seidemanmd.com',
    links: [],
  },
  // {
  //   name: 'Website',
  //   slug: 'annette-dauphinais-web',
  //   company: 'annette-dauphinais',
  //   images: [
  //     require('images/portfolio/annette-web/annette-web-0.jpg'),
  //   ],
  //   tech: ['JavaScript', 'HTML', 'PostCSS', 'React', 'Webpack', 'AWS'],
  //   description: [
  //     'Responsive website for the most trusted domestic assistant in the Upper Valley',
  //   ],
  //   dates: ['2017', '2019'],
  //   // website: 'https://annette.dauphina.is',
  //   links: [],
  // },
  {
    name: 'Website',
    slug: 'colby-dauphinais-web',
    company: 'colby-dauphinais',
    images: [
      require('images/portfolio/colby-website/colby-website-0.jpg'),
    ],
    tech: ['JavaScript', 'HTML', 'PostCSS', 'React', 'Ramda', 'Webpack', 'Enzyme', 'AWS'],
    description: [
      'You\'re on it!',
    ],
    dates: [],
    website: 'https://colby.dauphina.is',
    links: [],
  },
  {
    name: 'Leader',
    slug: 'codewars-leader',
    company: 'codewars',
    images: [
      require('images/portfolio/codewars/codewars-0.jpg'),
    ],
    tech: ['JavaScript', 'Python', 'Scala', 'Ruby',  'C#', 'Haskell', 'Clojure', 'Java'],
    description: [
      'Attained the #4 position (99th percentile) on the Codewars leaderboard, with over 1150 completed challenges',
    ],
    dates: ['2013'],
    website: 'https://web.archive.org/web/20160415075843/https://www.codewars.com/users/leaderboard',
    links: [
      'https://www.codewars.com/users/colbydauph',
    ],
  },
];



// WEBPACK FOOTER //
// ./src/data/projects.jsx